const formatTimeToCalendar = (utcDate?: string | null): string | null => {
  if (!utcDate) return null;

  return new Date(utcDate).toISOString().replace('Z', '');
};

const formatTimeToDisplayInEvent = (dateString?: string | null): string => {
  if (!dateString) return null;

  return new Date(dateString).toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  });
};

const formatDateToDisplayInEventDetails = (
  dateString?: string | null,
): string => {
  if (!dateString) return null;

  return new Date(dateString)
    .toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC',
    })
    .replace(',', ' às');
};

export {
  formatTimeToCalendar,
  formatTimeToDisplayInEvent,
  formatDateToDisplayInEventDetails,
};
